
export class MorePanel {
	/**
	 * @param content
	 * @param startOpen
	 * @param useSlide
	 * @param clickElement
	 * @param {boolean} leftSideTriangle set to true if the opening tringle will be placed on the left side and should point to the right when closed
	 */
	constructor(content, startOpen, useSlide, clickElement, leftSideTriangle = false) {
		this.blockGenerator = content;
		this.blockCache = null;
		this.open = startOpen;
		this.slide = useSlide;

		this.clickElement = clickElement;
		this.leftSideTriangle = leftSideTriangle;

		if (typeof this.blockGenerator !== 'function' || startOpen) this.blockVisiblity(startOpen, false);
	}

	get ui() {
		if (this.root == null) this.rebuild();
		return this.root;
	}

	get block() {
		if (this.blockCache === null) {
			if (typeof this.blockGenerator === 'function') this.blockCache = this.blockGenerator();
			else this.blockCache = this.blockGenerator;
		}
		return this.blockCache;
	}

	blockVisiblity(show, animated) {
		let block = this.block;
		let anime = typeof animated === 'undefined' ? this.slide : animated;
		if (show) {
			if (anime) block.slideDown();
			else block.show();
			if (this.root != null) this.root.removeClass('closed');
		} else {
			if (anime) block.slideUp();
			else block.hide();
			if (this.root != null) this.root.addClass('closed');
		}
		this.open = show;
	}

	toggle() {
		this.blockVisiblity(!this.open);
	}

	rebuild() {
		this.root = $(Icon.fi("triangle-down-14-full", "link-like-fi opener"));
		if (this.leftSideTriangle) this.root.addClass("left-opener");
		if (!this.open) this.root.addClass('closed');
		if (!this.clickElement) this.clickElement = this.root;
		// bind
		this.clickElement.on('click', this.toggle.bind(this));
	}
}
